import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49361bc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "w-full sm:w-1/2 sm:pr-30" }
const _hoisted_4 = { class: "sm:flex sm:flex-nowrap" }
const _hoisted_5 = { class: "w-full relative sm:w-1/2 sm:pr-30" }
const _hoisted_6 = {
  key: 0,
  class: "c-input__errors pin-x sm:pr-30"
}
const _hoisted_7 = { class: "w-full mt-x4 sm:mt-0 sm:w-1/2 sm:pl-30" }
const _hoisted_8 = {
  key: 0,
  class: "w-full"
}
const _hoisted_9 = { class: "o-text-caption block mb-13 sm:-mt-17" }
const _hoisted_10 = { class: "mt-x4 sm:w-190 sm:ml-auto" }
const _hoisted_11 = { class: "summary-line" }
const _hoisted_12 = { class: "whitespace-nowrap" }
const _hoisted_13 = { class: "summary-line text-18 md:text-20 xl:text-24" }
const _hoisted_14 = { class: "whitespace-nowrap" }
const _hoisted_15 = { class: "mt-x4 flex justify-end" }
const _hoisted_16 = {
  type: "button",
  class: "mr-x4"
}
const _hoisted_17 = ["disabled"]

import { Form } from 'vee-validate';
import useGiftPackaging, { maxAmountOfMessageLines } from '@/shared/checkout/gift-packaging/useGiftPackaging';
import useStoreContextBasket from '@/storecontext/basket/useBasket';
import useB2CBasket from '@/b2c/basket/useBasket';
import { AddGiftPackagingRequest, GiftPackingMessage } from '@/storecontext/shared/api/server-apis';
import InputTextarea from '@/shared/form/InputTextarea.vue';
import { computed, ref } from 'vue';
import authStore from '@/shared/auth/auth.store';
import WebApiMessage from '@/core/http/WebApiMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftPackagingDetails',
  setup(__props) {

const { details, labels, activeItemId, clearActiveItemId, getFormattedMessage } = useGiftPackaging();
const { addGiftPackingToItem: addGiftPackingToItemStoreContext } = useStoreContextBasket();
const { addGiftPackingToItem: addGiftPackingToItemB2C } = useB2CBasket();

const giftWrapWebApiMessageId = 'gift-packaging-message';
const message = ref<string>(details.value?.message?.message?.join('\n') ?? '');
const formattedMessage = computed<string[] | undefined>(() => {
    return getFormattedMessage(message.value);
});
const messageInvalid = computed<boolean>(() => {
    const lineCount = formattedMessage.value?.length ?? 0;
    return lineCount > maxAmountOfMessageLines;
});

const initialValues = {
    to: details.value?.message?.to ?? '',
    from: details.value?.message?.from ?? '',
};

const addToBasket = async({ to, from }: Partial<GiftPackingMessage>): void => {
    if (messageInvalid.value) {
        return;
    }
    const request: AddGiftPackagingRequest = {
        to,
        from,
        message: formattedMessage.value,
    };
    if (activeItemId.value) {
        try {
            if (authStore.isSignedInAsStore) {
                await addGiftPackingToItemStoreContext(activeItemId.value, request, giftWrapWebApiMessageId);
            } else {
                await addGiftPackingToItemB2C(activeItemId.value, request, giftWrapWebApiMessageId);
            }
            clearActiveItemId();
        } catch (error) {
            // Ignore error, as it will be handled by the global error handler
        }
    } else {
        clearActiveItemId();
    }
};


return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      innerHTML: _unref(labels).dialogHeaderAndDescriptionText
    }, null, 8, _hoisted_2),
    _createVNode(_unref(Form), {
      "initial-values": initialValues,
      class: "mt-x4",
      onSubmit: addToBasket
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_InputText, {
            name: "to",
            label: _unref(labels).cardTo,
            maxlength: "25"
          }, null, 8, ["label"]),
          _createVNode(_component_InputText, {
            name: "from",
            label: _unref(labels).cardFrom,
            maxlength: "25"
          }, null, 8, ["label"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(InputTextarea, {
              modelValue: message.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event)),
              name: "message",
              label: _unref(labels).cardMessage,
              class: "h-120 xl:h-150"
            }, null, 8, ["modelValue", "label"]),
            _createVNode(_Transition, { name: "o-anim-fade-300" }, {
              default: _withCtx(() => [
                (_unref(messageInvalid))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(labels).cardMessageInvalid), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(WebApiMessage, {
              id: giftWrapWebApiMessageId,
              "clear-timing": 8000,
              class: "mt-x2"
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_Transition, { name: "o-anim-fade-300" }, {
              default: _withCtx(() => [
                (_unref(formattedMessage).length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("strong", _hoisted_9, _toDisplayString(_unref(labels).cardMessagePreview), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(formattedMessage), (line, idx) => {
                        return (_openBlock(), _createElementBlock("p", {
                          key: line + idx
                        }, _toDisplayString(line || ''), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("dl", _hoisted_11, [
            _createElementVNode("dt", null, _toDisplayString(_unref(labels).packagingQuantity), 1),
            _createElementVNode("dd", _hoisted_12, _toDisplayString(_ctx.$dictionary.pluralize(_unref(details).option.quantity, _unref(labels).packagingQuantityPieceSingular, _unref(labels).packagingQuantityPiecePlural, { quantity: _unref(details).option.quantity })), 1)
          ]),
          _createElementVNode("dl", _hoisted_13, [
            _createElementVNode("dt", null, _toDisplayString(_unref(labels).totalPrice), 1),
            _createElementVNode("dd", _hoisted_14, _toDisplayString(_unref(details).option.totalPrice.amount), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", _hoisted_16, [
            _createElementVNode("span", {
              class: "c-magic-line c-magic-line--underline text-dusty-grey",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(clearActiveItemId)()), ["prevent"]))
            }, _toDisplayString(_unref(labels).cancelButtonText), 1)
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: "c-button c-button--primary min-w-100",
            disabled: _unref(messageInvalid)
          }, _toDisplayString(_unref(labels).saveButtonText), 9, _hoisted_17)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})